<template lang="pug">
	div
		.fondoUpdate(:class="mostrar ? 'show' : ''")
		.cajaUpdate(:class="mostrar ? 'show' : (ocultar) ? 'hide' : ''")
			.card
				.card-body.text-center
					img(src="/static/recursos/logo_sip.svg", style="height:35px;margin-bottom: 15px;", alt="")
					h5
						b Actualización disponible
					//- .stage
					//- 	.dot-floating(style="")
				.card-body.bg-light(style="border-top: 1px solid #e0e0e0;")
					.filaVersion(style="color: #999999;")
						.nombre
							h5
								b Versión actual
						.version
							h5
								b {{ actual}}
					.filaVersion
						.nombre
							h5
								b Nueva versión
						.version
							h5
								b {{ version }}
				.card-footer
					button.m-2.btn.btn-primary(@click="actualizar()")
						span.fa.fa-check.mr-2
						| Actualizar
					button.m-2.btn.btn-danger(@click="posponer()", :disabled="pospuesto")
						span.fa.fa-clock-o.mr-2
						| Posponer
					p(v-if="!pospuesto")
						i
							span Solo podrás posponer <b>una vez</b> la actualización.
							br
							span Tendrás <b>5 minutos</b> hasta el siguiente aviso.
					p(v-else)
						i Ya has pospuesto antes la actualización
</template>

<script>
export default {
	props: ['version', 'actual', 'pospuesto'],
	data () {
		return {
			mostrar: false,
			ocultar: false
		}
	},
	mounted () {
		window.setTimeout(() => {
			this.mostrar = true
		}, 300)
	},
	methods: {
		actualizar () {
			window.location.reload(true)
		},
		posponer () {
			this.mostrar = false
			this.ocultar = true
			this.$emit('posponer')
		}
	}
}
</script>
<style scoped>
.fondoUpdate {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;

	background-color: rgb(30, 30, 30);
	transition: opacity 800ms ease-in-out;
	opacity: 0;
}

.fondoUpdate.show {
	opacity: 0.6;
}

.cajaUpdate {
	position: absolute;
	display: block;
	left: 50%;
	transform: translateY(-130%);
	z-index: 1001;
	color: #555555;
}

.cajaUpdate.show {
	/* transition: transform 500ms easeOutBounce; */
	transition: all 1000ms cubic-bezier(0.500, 1.650, 0.515, 0.885); /* custom */
	transform: translateY(100px);
}

.cajaUpdate.hide {
	transition: all 1000ms cubic-bezier(0.160, 0.055, 0.695, -0.475); /* custom */
}

.cajaUpdate > div {
	position: relative;
	left: -50%;
}

.filaVersion {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-bottom: 10px;
}

.filaVersion > .nombre {
	flex-grow: 1;
	text-align: left;
}

.filaVersion > .version {
	flex-grow: 1;
	text-align: right;
}

/* Three dots */
.stage {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	padding: 1rem 0;
	margin: 0 -5%;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/update/update.vue